import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ListFilterPopover = _resolveComponent("ListFilterPopover")!

  return (_openBlock(), _createBlock(_component_ListFilterPopover, {
    "is-filter-visible": _ctx.isFilterVisible,
    "is-filter-active": _ctx.isFilterActive,
    "is-filter-loading": _ctx.isRealMoneyBalancePlayerListLoading,
    onCloseFilter: _ctx.toggleFilterVisibility,
    onSubmitFilter: _ctx.submitFilter,
    onResetFilter: _ctx.resetFilter
  }, {
    "filter-content": _withCtx(() => [
      _createVNode(_component_el_form, {
        model: _ctx.filterFormData,
        "label-position": "top",
        class: "mga-real-money-balance-page-list-filter"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Group by",
            class: "mga-real-money-balance-page-list-filter__item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.filterFormData.groupByDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterFormData.groupByDate) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.GROUP_BY_OPTIONS, ({ value, label }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: value,
                      class: "mga-real-money-balance-page-list-filter__item",
                      label: label,
                      value: value
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, { label: "Player ID" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.filterFormData.playerId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterFormData.playerId) = $event)),
                placeholder: "Enter Player ID",
                type: "number",
                clearable: ""
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            class: "mga-real-money-balance-page-list-filter__item",
            label: "From"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.filterFormData.dateFrom,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterFormData.dateFrom) = $event)),
                type: "datetime",
                placeholder: "Select date and time",
                clearable: ""
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            class: "mga-real-money-balance-page-list-filter__item",
            label: "To"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.filterFormData.dateTo,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterFormData.dateTo) = $event)),
                type: "datetime",
                placeholder: "Select date and time",
                clearable: ""
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            class: "mga-real-money-balance-page-list-filter__item",
            label: "Exchange rate date"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.filterFormData.exchangeRateDate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterFormData.exchangeRateDate) = $event)),
                type: "datetime",
                placeholder: "Select date and time",
                clearable: ""
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-filter-visible", "is-filter-active", "is-filter-loading", "onCloseFilter", "onSubmitFilter", "onResetFilter"]))
}